import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { SexEnum } from 'server/shared/models/sex.enum';
@Component({
  selector: 'app-sex-select',
  templateUrl: './sex-select.component.html',
  styleUrls: ['./sex-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SexSelectComponent,
      multi: true,
    },
  ],
})
export class SexSelectComponent implements ControlValueAccessor {
  readonly sexEnum = SexEnum;

  isDisabled$ = new BehaviorSubject<boolean>(false);
  isRequired$ = new BehaviorSubject<boolean>(false);
  @Input() set isRequired(value: boolean) {
    this.isRequired$.next(value);
  }
  get isRequired() {
    return this.isRequired$.value;
  }

  useSalutation$ = new BehaviorSubject<boolean>(false);
  @Input() set useSalutation(value: boolean) {
    this.useSalutation$.next(value);
  }
  get useSalutation() {
    return this.useSalutation$.value;
  }

  selectedValue$ = new BehaviorSubject<SexEnum | undefined>(undefined);
  hintContent$ = new BehaviorSubject<TemplateRef<any> | undefined>(undefined);

  @ContentChild('hint') set hintContent(value: TemplateRef<any> | undefined) {
    this.hintContent$.next(value);
  }
  get hintContent() {
    return this.hintContent$.value;
  }

  onChange: any = (sex: SexEnum) => {};
  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  onTouch: any = () => {};
  registerOnTouched(onTouched: Function) {
    this.onTouch = onTouched;
  }

  constructor() {}

  setDisabledState(isDisabled: boolean) {
    this.isDisabled$.next(isDisabled);
  }

  writeValue(value: SexEnum) {
    this.selectedValue$.next(value);
  }

  selectionChanged(sex: SexEnum) {
    this.selectedValue$.next(sex);
    this.onChange(sex);
  }
}
